import classNames from "classnames";
import React, { useMemo } from "react";

export type TabOption = {
  label: string;
  value: string;
};

type TabProps = {
  options: TabOption[];
  activeValue: string;
  onChange: (value: string) => void;
};

export const Tabs: React.FC<TabProps> = ({
  options,
  activeValue,
  onChange,
}) => {
  const values = useMemo(() => options.map((x) => x.value), [options]);
  const activeIndex = values.indexOf(activeValue);

  return (
    <div className="relative w-full max-w-xs overflow-hidden  mx-auto text-primary-dark">
      <div className=" bg-white flex justify-between border border-[#CACACA] rounded-[14px] overflow-hidden p-2">
        {options.map(({ label, value }) => (
          <button
            key={value}
            onClick={() => onChange(value)}
            className={classNames(
              "flex-1 py-3 rounded-[12px] text-center text-sm",
              {
                "bg-success text-white": activeValue === value,
                "bg-transparent": activeValue !== value,
              }
            )}
          >
            {label}
          </button>
        ))}
      </div>
      <div
        className={`absolute top-0 h-full w-1/${options.length} rounded-lg transition-transform duration-300 ease-in-out transform`}
        style={{ transform: `translateX(${activeIndex * 100}%)` }}
      />
    </div>
  );
};
